import { reactive } from 'vue'
import AXIOS from '@/common/axios.js'

const isLocal = window.location.host.indexOf("localhost") > -1;
const domain = isLocal ? 'http://localhost:8080' : 'https://workflow.premia-partners.com';
const cms_domain = isLocal ? 'http://localhost:8080' : 'https://cms.premia-partners.com';
const robo_domain = isLocal ? 'http://localhost:8080' : 'https://robo.premia-partners.com';
const host = window.location.host.indexOf("premia-partners.com") != -1 ? "premia-partners.com" : null;

const global = reactive({
    isLocal: isLocal,
    currentUser: null,
    token: '',
    rights: null,
    upload_domain: domain,
    api_domain:    domain + '/user-api',
    upload_path:   domain + '/user-api/uploadFiles',
    cms_domain: cms_domain,
    robo_domain: robo_domain,
    index: null,

    down(path, name) {
        window.location.href = global.api_domain + '/down?path=' + encodeURIComponent(path) + '&name=' + encodeURIComponent(name);
    },
    setCurrentUser(user) {
        this.currentUser = user;
        if (user) {
            localStorage.setItem("currentUser", JSON.stringify(user));
        } else {
            localStorage.removeItem("currentUser");
        }
    },
    setToken(token) {
        this.token = token;
        if (token) {
            localStorage.setItem("token", token);
        } else {
            localStorage.removeItem("token");
        }
    },
    setRights(rights) {
        this.rights = rights;
        if (rights) {
            localStorage.setItem("rights", JSON.stringify(rights));
        } else {
            localStorage.removeItem("rights");
        }
    },
    logout() {
        this.setToken(null);
        this.setCurrentUser(null);
        this.setRights(null);
        this.clearCookie("sid", "/", host);
    },
    
    setIndex(index) {
        this.index = index;
    },
    hasRight(system, role) {
        if (this.rights == null) 
            return false;
        if (system) system = system.toLowerCase();
        if (role) role = role.toLowerCase();
        let roles = this.rights[system];
        if (roles) roles = roles.toLowerCase();
        if (role) 
            return (roles && roles.indexOf(role) > -1);
        else 
            return roles ? true : false;
    },
    hasAuth(system) {
        if (this.rights == null) 
            return false;
        if (system) 
            system = system.toLowerCase();
        return this.rights[system] != null;
    },
    openwin(url) {
        var a = document.createElement("a");
        a.setAttribute("href", url);
        a.setAttribute("target", "_blank");
        document.body.appendChild(a);
        a.click();
    },
    number_format(number, prec) {
        if (number == null || number == undefined)
            number = 0;
        let s = number.toFixed(prec);
        let intPart = s.split(".")[0];
        let intStr = '';
        let count = 0;
        for (var i = intPart.length-1; i > 0; i--) 
            intStr = (++count % 3 == 0 ? "," : "") + intPart.charAt(i) + intStr;
        intStr = intPart.charAt(0) + intStr;
        return intStr + (prec > 0 ? s.substring(s.indexOf('.')) : "");
    },
    async getAllUsers() {
        let allUsers = null;
        let result = await AXIOS('/user/getAllUsers', null);
        if (result.success) {
            allUsers = result.data;
        } else {
            console.log("getAllUsers failed " + result.errMsg);
        }
        return allUsers;
    },
    setCookie(name, value, expireDays, path, domain) {
        var cookieStr = name + "=" + escape(value);
        if (expireDays != 0) {
            var exp = new Date();
            exp.setTime(exp.getTime() + expireDays * 24*60*60*1000);
            cookieStr += "; expires=" + exp.toGMTString();
        }
        if (path != null) {
            cookieStr += "; path=" + path;
        }
        if (domain != null) {
            cookieStr += "; domain=" + domain;
        }
        document.cookie = cookieStr;
    },
    clearCookie(name, path, domain) {
        var cookieStr = name + "=; expires=" + new Date().toGMTString();
        if (path != null) 
            cookieStr += "; path=" + path;
        if (domain != null) 
            cookieStr += "; domain=" + domain;
        document.cookie = cookieStr;
    },
    dateToString(date) {
        let yyyy = date.getFullYear();
        let m = date.getMonth()+1;
        let d = date.getDate();
        return yyyy + "-" + (m < 10 ? "0" : "") + m + "-" + (d < 10 ? "0" : "") + d;
    }
});

export default global;